export const arrow_up_right = () => (
  <path
    d="M7 17L17 7m0 0H7m10 0v10"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
